import { omit } from 'lodash';

export default ['$http', '$location', 'storeService', function ($http, $location, storeService) {
    const defaultConfig = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    };

    const buildUrl = url => `//${$location.host()}/${url}`;

    const fieldBlacklist = ['uuid', 'id', '_embedded', '_links', 'created_at', 'updated_at'];

    const makeRequest = (method, url, data, config = defaultConfig) => {
        config = Object.assign({}, defaultConfig, config);

        // Header seems to be cached somehow, so forcing a reset if not valid
        config.headers['Core-Client'] = storeService.get('client_id') || undefined;
        config.headers['Reservation'] = storeService.get('reservation') || undefined;

        url = buildUrl(url);

        data = data ? omit(data, fieldBlacklist) : data;

        return data ?
            method(url, data, config) :
            method(url, config);
    };

    return {
        get: (url, config) => makeRequest($http.get, url, null, config),
        post: (url, data) => makeRequest($http.post, url, data),
        delete: (url) => makeRequest($http.delete, url, null)
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/basket/services/api.service.js